
module.exports = {

  CHECKBOX_STATE: {
    CHECKED: 1,
    UNCHECKED: 2,
    UNDETERMINED: 3
  }

}



// WEBPACK FOOTER //
// ./src/deni-react-treeview-item/deni-react-treeview-item.constant.js